export const FLAG_GETTING_DOCUMENT_TYPES = 'FLAG_GETTING_DOCUMENT_TYPES';
export const GET_DOCUMENT_TYPES = 'GET_DOCUMENT_TYPES';
export const CLEAR_DOCUMENT_TYPES = 'CLEAR_DOCUMENT_TYPES';
export const FLAG_GETTING_DOCUMENT_TYPE = 'FLAG_GETTING_DOCUMENT_TYPE';
export const GET_DOCUMENT_TYPE = 'GET_DOCUMENT_TYPE';
export const CLEAR_DOCUMENT_TYPE = 'CLEAR_DOCUMENT_TYPE';
